import { render, staticRenderFns } from "./reward-recordv2.vue?vue&type=template&id=3aef1a5c&scoped=true&"
import script from "./reward-recordv2.vue?vue&type=script&lang=js&"
export * from "./reward-recordv2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aef1a5c",
  null
  
)

export default component.exports